export default __webpack_public_path__ + "static/ManageAccountant-ee1bb2f99ee4f49852bb5f806a693f8a.png";